import React, { useState, useEffect } from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';
import { InputBox } from '../FormComponent';

const WordCountTextarea = ({
  value,
  onChange,
  wordLimit = 100,
  minWords = 40, // Minimum word count
  setIsAboveLength,
  setIsBelowLength,
  placeholder,
  disabled,
  error=false,
  onFocus,
  onBlur,
  maxWordLimit
}) => {
  const [inputText, setInputText] = useState(value || '');

  // Update inputText whenever the value prop changes
  useEffect(() => {
    setInputText(value || '');
  }, [value]);

  // Track word count and update isAboveLength and isBelowLength
  useEffect(() => {
    const wordCount = inputText.split(/\s+/).filter((word) => word).length;
    setIsAboveLength(wordCount > wordLimit); // Set isAboveLength based on word count
    setIsBelowLength(wordCount < minWords); // Set isBelowLength if below min words
  }, [inputText, wordLimit, minWords, setIsAboveLength, setIsBelowLength]);

  const handleChange = (event) => {
    const text = event.target.value;
    setInputText(text);
    onChange(text);
  };

  const wordCount = inputText.split(/\s+/).filter((word) => word).length;

  return (
    <Box 
    sx={{ position: 'relative', width: '100%' }}>
      <InputBox 
        id="outlined-multiline-flexible"
        value={inputText}
        onChange={handleChange}
        disabled={disabled}
        multiline 
        rows={4}
        placeholder="Enter a problem statement, design description, user story, or any other relevant details for which you'd like to generate test scenarios. Please be as specific as possible to ensure the best results."
        helperText={`${inputText.split(/\s+/).filter(Boolean).length}/${wordLimit} words`}
        error={wordCount > wordLimit ? `Word limit exceeded! Maximum allowed is ${wordLimit} words. Currently: ${wordCount}` : wordLimit.length>0 ? "Inputting at least 25 words is mandatory to generate a scenario. Please provide sufficient details to ensure accurate results.": ""}
      />
    </Box>

  );
};

export default WordCountTextarea;